export const DE = {

index:{
title_general: "Tauchsimulator",
que_hace_txt: "Was er macht?",
objetivo: "Das Ziel ist nicht, das Tauchen zu simulieren, sondern den echten Taucher zu verbessern.",
modelos_txt_1: "Modelle",
instrumentos_txt: "Instrumente",
seguridad_txt: "Sicherheit",

que_se_pierde: "Was geht verloren, wenn Tauchen ohne Simulation unterrichtet wird?",
teoria_de_perdida: `

        <span style="color:#dfbb73;font-size: 20px;">"Die Theorie lehrt, was zu tun ist. Die Simulation lehrt, warum es zu tun ist"</span>

        <br><br>Ohne Simulation bleiben viele Konzepte abstrakt. Die Schüler lernen Grenzen, Verfahren und Tabellen auswendig, haben aber Schwierigkeiten zu visualisieren, wie sich ihre Entscheidungen tatsächlich auf die Gasaufnahme, die Dekompression, die Sauerstoffbelastung und die Sicherheit des Tauchgangs auswirken.
        <br><br>Die Simulation verwandelt unsichtbare Prozesse in visuelle und interaktive Erlebnisse. Sie ermöglicht es, Szenarien durchzuspielen, Konsequenzen zu analysieren und zu verstehen, wie kleine Änderungen der Tiefe, der Zeit oder der Aufstiegsgeschwindigkeit ein ganzes Tauchprofil verändern können.
        <br><br>Für die Tauchlehrer bedeutet dies den Übergang vom Erklären von Konzepten zum Demonstrieren ihrer Funktionsweise in Echtzeit.
        <br><strong>Denn das Ziel ist nicht, dass sich der Schüler an eine Regel erinnert. Es geht darum, dass er die Konsequenzen seiner Entscheidungen versteht, bevor er ins Wasser geht.</strong>`,



faq_txt: "FAQ",
login_txt: "Login",

experiencia_interactiva: "Tauchsimulator | Trockentraining",

que_hace_2: "Divantys hilft Ihnen, das Tauchen zu verstehen, bevor Sie ins Wasser gehen, wodurch Risiken reduziert, das Lernen beschleunigt und echte Entscheidungen unter Druck verbessert werden.",



visualiza: "Beherrsche die Tauchtheorie. <strong>Lerne deine Tauchgänge zu steuern und zu optimieren</strong>, bevor du ins Wasser gehst",
que_hace_4: `
                <strong>Tauchen ist teuer; Lernen muss es nicht sein.</strong><br>
                Übe im Simulator und nicht während eines Tauchgangs, für den du bezahlst.<br>
                Trainiere an Land, sammle Erfahrung und nutze jede Minute deines Unterwasserabenteuers optimal.`,


        all_levels: "Für Anfänger, Schüler bis hin zu fortgeschrittenen Tauchern und Tauchlehrern", 
safety_gestion: "Sicherheitsstopps verwalten und durchführen",
aire_profundidad: "Verlängere deine Tauchgänge durch Tiefenmanagement",
gestion_deco: "Dekompressionsstopps verwalten und durchführen",
ppo2_gestion: "PPO2 mit der Tiefe verwalten und visualisieren",

openModalBtn: "Zusammenfassung anzeigen",

ilustra: `
Der Simulator lehrt dich, richtig auf Fehler zu reagieren,
  indem er dir die Zukunft deiner Entscheidungen zeigt, bevor du ins Wasser gehst.
`,
preguntas_estrategicas_aprendizaje: `
Die wirklich wichtige Frage ist also:<br>
  <ul>
    <li>Was würde passieren, wenn ich eine andere Entscheidung treffen würde?</li>
    <li>Was passiert, wenn ich fünf Minuten länger am Boden bleibe?</li>
    <li>Was passiert, wenn ich zu schnell aufsteige?</li>
    <li>Wie verändern sich meine Gewebe, wenn ich ein anderes Gasgemisch verwende?</li>
    <li>Wie wirkt sich ein tieferer oder längerer Stopp auf mein Dekompressionsprofil aus?</li>
  </ul>
Die Simulation ermöglicht es, diese Fragen sofort, visuell und sicher zu beantworten.`,

relacion_pp: "Fehler vorauszusehen ist der größte Fortschritt eines Tauchers",
ndl: "Nullzeitgrenzen (NDL)",
absorcion: "Stickstoffaufnahme (Gewebe)",
exposicion: "Sauerstoffexposition (PPO₂ / CNS)",
habitos_asenso: "Sicherere Aufstiegsgewohnheiten",
consumo_aire: "Luftverbrauch und Reserve",
buceo_recreativo: "Sporttauchen",
nitrox_compatible: "Nitrox-kompatibel",
hud: "HUD auf dem Bildschirm",
mobil_desktop: "Mobil + Desktop",
startCta: "Simulator starten",
que_incluye: "Sieh, was enthalten ist",
tiempo: "Tipp: Du kannst die Zeit beschleunigen, um die Entwicklung der Anzeigen schneller zu beobachten (z. B. 2×, 5× oder 10×).",
que_hace_3: "Was dieser Simulator macht",
inmersion_virtual: "Divantys Dive Simulator ist eine interaktive Plattform zur Simulation und zum Lernen des Tauchens, die es ermöglicht, die physikalischen und physiologischen Prozesse, die während eines Tauchgangs ablaufen, in Echtzeit visuell darzustellen. Ihr Ziel ist es, komplexe Konzepte der Tauchteorie, Dekompression und menschlichen Physiologie in eine leicht verständliche visuelle Erfahrung für Taucher, Studenten, Tauchlehrer und Branchenprofis zu verwandeln. Divantys als virtuelles Labor, in dem man erforschen kann, wie der menschliche Körper auf verschiedene Tauchprofile, Gasgemische, Tiefen und Expositionszeiten reagiert.",
experiencia_3d: "Steuerbare 3D-Erfahrung",
movimiento_cacara: "Bewegung und Kamera mit angepassten Steuerungen für Mobilgeräte, Tablets und PC.",
joistick_movimiento: "Bewegungs-Joystick",
joistick_rotacion: "Blick-/Rotations-Joystick",
neutral_flotabilidad: "Neutralzone für Stabilität",
indicadores_hud: "HUD-Anzeigen",
instrumentos_visuales: "Visuelle Instrumente auf dem Bildschirm für sofortiges Verständnis.",
tanque: "Tank: bar / PSI / Prozent",
barra_nitrogeno: "Stickstoffbalken (didaktisch)",
ndl_estado: "NDL und Aufstiegsstatus",
reporte: "Vollständiger Bericht",
resumen: "Tauchzusammenfassung für Lernen und Analyse.",
profundidad_maxima: "Maximale Tiefe",
tiempo_total: "Gesamtzeit",
ndl_total: "Gesamte und verbleibende NDL",
ceiling: "Ceiling (minimale sichere Tiefe)",
modelos_txt: "Modelle und dargestellte Konzepte",
simulador_implementa: "Der Simulator implementiert physiologische Modelle und gängige Lehrregeln des Sporttauchens: Aufnahme und Abgabe von Stickstoff durch Gewebe, Nullzeitgrenzen und Sauerstoffexposition.",
modelo_tejidos: "Gewebemodell (16 Kompartimente)",
simulador_carge_nitrogeno: "Simuliert die Stickstoffaufnahme in verschiedenen Geweben mit unterschiedlichen Geschwindigkeiten und ermöglicht die Abschätzung von Sättigung, „Ceiling“ und Verhalten bei Wiederholungstauchgängen.",
expoosicion_o2: "Sauerstoffexposition (PPO₂ / CNS)",
calculo_po2: "Berechnet den PPO₂ basierend auf Tiefe und Sauerstoffanteil (FO₂) und akkumuliert die CNS-Exposition anhand eines PPO₂-basierten Grenzwertmodells. Enthält Alarmstufen (OK / WARNING / DANGER).",
ndl2: "NDL (Nullzeitgrenze)",
caluclo_ndl: "Berechnet eine „recreational“ NDL basierend auf Tiefe und Zeit, mit Unterstützung für Nitrox (EAD).",
ndl_total_permitido: "Gesamt erlaubte NDL",
ndl_restante: "Verbleibende NDL basierend auf dem Profil",
interpretacion_riesgos: "Didaktische Interpretation des Risikos",
ceiling_asecenso: "Ceiling und Aufstieg",
estimacion_profundidad_ceiling: "Schätzt eine minimale sichere Tiefe (Ceiling) und bewertet, ob der Aufstieg ohne Stopps durchgeführt werden kann.",
ceiling_metros: "Ceiling in Metern",
deteccion_parada: "Erkennung „Stopp erforderlich“",
recomendacion_parada: "Empfehlung für Sicherheitsstopp",
inmersiones_repetitivas: "Wiederholungstauchgänge",
carga_residual: "Behält Restbelastung zwischen Tauchgängen bei und simuliert Oberflächenintervalle.",
tejidos_conservan: "Gewebe bleiben zwischen Tauchgängen erhalten",
intervalo_superficie: "Oberflächenintervall reduziert die Belastung",
aprendizaje_acumulacion: "Lernen der Restakkumulation",
instrumentos_visualizacion_hud: "Instrumente und Visualisierung (HUD)",
facilitar_comprension: "Um das Verständnis zu erleichtern, zeigt der Simulator während des Tauchgangs visuelle Instrumente auf dem Bildschirm an. Ziel ist es, dass der Benutzer „sieht“, wie sich die Konzepte durch sein Verhalten verändern.",
tanque_aire: "Lufttank (AL80)",
simula_consumo_sac: "Simuliert den Verbrauch basierend auf SAC, Umgebungsdruck und simulierter Zeit.",
presion_bar_psi: "Druck in bar und PSI",
gas_restante: "Verbleibender Prozentsatz",
alerta_reserva: "Reservemeldung (z. B. 35 bar)",
sin_aire: "„Kein Luft“-Zustand (out of air)",
barra_nitrogeno_2: "Stickstoffbalken",
visualizacion_educativa: "Didaktische Visualisierung der Zu-/Abnahme der Belastung.",
suavisado_visual: "Visuelle Glättung (langsames Laden / normales Entladen)",
colores_nivel: "Farben nach Niveau (grün→rot)",
enfoque_didactico: "Didaktischer Ansatz, leicht verständlich",
ndk_y_estado_ascenso: "NDL und Aufstiegsstatus",
indicadores_limites_descompresion: "Indikatoren zum Verständnis von Nullzeitgrenzen und Aufstiegsgewohnheiten.",
ndl_restante_2: "Verbleibende NDL",
recomendacion_parada_2: "Empfehlung für Sicherheitsstopp",
ceiling_si_aplica: "Ceiling (falls zutreffend)",
escala_tiempo_safety_stop: "Zeitskala (1×, 2×, 5×, 10×)",
acelerar_tiempo: "Du kannst die Simulation beschleunigen, um schneller zu sehen, wie sich die Werte verändern. Diese Funktion ist nützlich für die Ausbildung: Sie zeigt Trends der Anzeigen, ohne lange warten zu müssen.",
safety_stop_title: "Sicherheitsstopp (Freizeittauchen)",
safety_stop_resumen: "Dieses Modul simuliert den Sicherheitsstopp bei 5 Metern im Sporttauchen. Seine Logik basiert auf skalierter Echtzeitsteuerung, Tiefentoleranz sowie der Erkennung von Unterbrechungen oder erneuten Abstiegen zur Validierung oder Ungültigmachung des Stopps.",
deteccion_recomendacion: "Stopp-Empfehlung",
safety_recommendation_meta: "Der Stopp wird automatisch basierend auf dem Tauchprofil empfohlen.",
profundidad_maxima_safety_stop: "Aktiviert, wenn die maximale Tiefe 10 m überschreitet",
exclusion_descompresion: "Deaktiviert, wenn aktive oder erforderliche Dekompression vorliegt",
estado_recomendado: "Status: recommended → aktiviert den Sicherheitsstopp",
callback_recomendacion: "Optionaler Callback zur Benutzerbenachrichtigung",
logica_ejecucion: "Ausführungslogik",
safety_execution_meta: "Das System steuert die Zeit in der 5-Meter-Zone mit Toleranz und Zeitskalierung.",
zona_parada: "Stoppzone: 5 m ± 2 m",
zona_pausa: "Pausenzone: 5 m - 3 m (kein Fortschritt)",
acumulacion_tiempo_safety_stop: "Zeitakkumulation in simulierten Sekunden",
escala_tiempo: "Skalierung durch Simulationsgeschwindigkeit (GET_TIME_SCALE)",
completado_3min: "Abgeschlossen nach 180 effektiven Sekunden",
pausa_reanuda: "Automatische Pause beim Verlassen der Zone",
interrupciones_redescenso: "Unterbrechungen und erneutes Abtauchen",
safety_interrupt_meta: "Erkennt, ob der Taucher den Stopp verlässt oder nach Abschluss wieder in die Tiefe geht.",
rompe_parada: "Verlassen der Zone macht den Fortschritt ungültig",
cancelacion: "Status „cancelled“ startet das Tracking neu",
interrupted_flag: "Markiert eine Unterbrechung, wenn die Logik gebrochen wird",
redescenso_invalida: "Erneutes Abtauchen > 6 m aktiviert die Empfehlung erneut",
ventana_tiempo: "30-s-Fenster für Ungültigmachung nach Abschluss",
safety_stop_tiempo: "Zeitkontrolle beim Stopp",
safety_stop_explicacion: "Die Zeit wird in simulierter Echtzeit berechnet und nur akkumuliert, wenn sich der Taucher im richtigen Bereich befindet. Verlässt er die Zone, pausiert der Zähler. Nach 3 effektiven Minuten gilt der Stopp als abgeschlossen. Ein späteres erneutes Abtauchen kann ihn jedoch unter bestimmten physiologischen Bedingungen ungültig machen.",
nitrogen_load_title: "Stickstoffbelastungsbalken (didaktische UI)",
nitrogen_load_resumen: "Dieses Modul visualisiert in Echtzeit die Stickstoffbelastung in den schnellen Geweben des Tauchers. Ziel ist es, didaktisch zu zeigen, wie sich die relative Sättigung während des Tauchgangs anhand eines geglätteten und farbcodierten Fortschrittsbalkens entwickelt.",
visualizacion_n2: "N₂-Belastungsvisualisierung",
n2_visual_meta: "Stellt vereinfacht das Niveau der Stickstoffsättigung in schnellen Geweben dar.",


ppo2_vizualiza:"PPO₂ und CNS",
    ppo2_visualiza_desc:"Visualisieren Sie die Sauerstofftoxizität anhand von PPO₂ und der kumulierten CNS-Belastung. Der Status wird durch physiologische Risikostufen dargestellt.",
    ppo2_visualiza_p1:"Anschauliche Farben für Toxizitätsstufen",
    ppo2_visualiza_p2:"Kumuliertes CNS",

    profundimetro:"Echtzeit-Tiefe",
    profundimetro_educativa:"Kontinuierliche Tiefenüberwachung zum besseren Verständnis der Entwicklung des Tauchprofils.",
    profundimetro_visualiza_p1:"Dynamische Tiefenaktualisierung während des gesamten Tauchgangs.",
    profundimetro_visualiza_p2:"Visuelle Glättung, die das Verhalten realer Instrumente simuliert.",





tejidos_rapidos: "Basierend auf schnellen Geweben des physiologischen Modells",
valor_porcentual: "Wert als Prozentsatz angegeben (0–130%)",
suavizado_visual_2: "Visuelle Glättung zur Vermeidung abrupter Sprünge",
actualizacion_tiempo_real: "Echtzeit-Aktualisierung",
codigo_colores_n2: "Farbcodierung",
n2_colors_meta: "Die Leiste ändert ihre Farbe je nach Belastungsniveau, um eine schnelle Interpretation zu erleichtern.",
verde_seguro: "Grün: geringe und stabile Belastung (< 60%)",
amarillo_atencion: "Gelb: Aufmerksamkeitsbereich (60%–85%)",
naranja_alto: "Orange: hohe Belastung (85%–100%)",
rojo_riesgo: "Rot: potenzielle Übersättigung (> 100%)",
logica_suavizado: "Glättungs- und Stabilitätslogik",
n2_smoothing_meta: "Der visuelle Wert ändert sich nicht sofort, sondern nähert sich schrittweise dem realen Wert an.",
interpolacion_visual: "Progressive Interpolation (Ease-in / Ease-out)",
respuesta_diferencial: "Langsamere Reaktion beim Anstieg als beim Abfall",
prevencion_flicker: "Verhinderung von visuellem Flackern",
clamp_visual: "Begrenzung der Werte zwischen 0% und 130%",
n2_bar_texto_secundario: "Sekundäre Informationen (GF / physiologischer Zustand)",
n2_bar_explicacion: "Die Leiste kann zusätzlichen Text enthalten (z. B. Gradient Factor oder Zustand des physiologischen Modells). Dies ermöglicht eine visuelle Korrelation zwischen Stickstoffsättigung und Dekompressionsstatus und bietet eine intuitivere Darstellung des akkumulierten Risikos.",
air_consumption_title: "Luftverbrauch (AL80 Mehrflaschensystem)",
air_consumption_resumen: "Dieses Modul simuliert den realen Gasverbrauch in dynamischer Zeit unter Verwendung von SAC (Surface Air Consumption), Umgebungsdruck und Zeitskalierung. Es unterstützt Einzel- oder Mehrflaschenkonfigurationen und berechnet die fortschreitende Entleerung des gesamten Systems.",
modelo_consumo: "Verbrauchsmodell",
air_model_meta: "Der Verbrauch basiert auf dem SAC des Tauchers, angepasst an den Umgebungsdruck und die simulierte Zeit.",
sac_rate: "Benutzerkonfigurierbarer SAC",
presion_ambiente: "Umgebungsdruck = 1 + Tiefe/10",
escala_tiempo_aire: "Skaliert durch GET_TIME_SCALE()",
consumo_proporcional: "Proportionaler Verbrauch pro Flasche",
sistema_multitanque: "Mehrflaschensystem",
air_tanks_meta: "Das System verteilt den Verbrauch auf alle aktiven Flaschen im Setup.",
al80_base: "Basisflasche AL80 (2265 L)",
multi_tank_support: "Unterstützung für mehrere Flaschen",
division_consumo: "Verbrauch auf aktive Flaschen verteilt",
estado_out_of_air: "Globaler Zustand OUT OF AIR",
visualizacion_hud_aire: "HUD-Anzeige",
air_hud_meta: "Jede Flasche wird mit einer vertikalen Füllstandsanzeige und Druckanzeige in bar und PSI dargestellt.",
nivel_visual_barra: "Visueller Füllstand nach Volumenprozentsatz",
bar_psi_conversion: "Echtzeit-Umrechnung bar / PSI",
colores_reserva: "Farbe je nach Reserve (Grün → Orange → Rot)",
alerta_reserva_aire: "Warnung unter 35 bar",
air_system_tank_title: "Status des Luftsystems",
air_system_explainer: "Das System berechnet das verbleibende Gesamtvolumen durch Summierung aller aktiven Flaschen. Der Verbrauch wird bei jedem simulierten Frame aktualisiert und ermöglicht die Erkennung des Reservepunkts oder eines kritischen „keine Luft“-Zustands. Das Modell spiegelt sowohl individuellen als auch globalen Verbrauch wider.",
oxygen_toxicity_title: "Sauerstofftoxizität (NOAA CNS)",
oxygen_toxicity_resumen: "Dieses Modul bewertet das Risiko der Sauerstofftoxizität anhand von PPO₂ und akkumuliertem CNS. Der Zustand wird durch physiologische Risikostufen ähnlich einem Tauchcomputer dargestellt.",
ppo2_model: "Sauerstoff-Partialdruck (PPO₂)",
ppo2_meta: "Bestimmt das unmittelbare Risiko akuter Toxizität.",
formula_ppo2: "PPO₂ = FO₂ × Umgebungsdruck",
limite_ppo2: "Betriebsgrenze: 1,4 bar",
limite_critico: "Kritisch: ≥ 1,6 bar",
cns_model: "CNS (Zentrales Nervensystem)",
cns_meta: "Progressive Akkumulation der Sauerstoffexposition gemäß NOAA-Modell.",
noaa_model: "NOAA-Expositionsmodell",
acumulacion_cns: "Progressiver Anstieg über die Zeit",
limite_cns: "100% = empfohlene Grenze",
estado_oxigeno: "Zustand der Sauerstofftoxizität",
oxy_state_meta: "Kombinierte Bewertung von PPO₂ und CNS in Echtzeit.",
stateOK: "OK",
stateWARN: "WARNUNG",
stateDANGER: "GEFAHR",
state_ok: "OK: Exposition innerhalb sicherer Grenzen",
state_warning: "WARNUNG: Vorsichtsbereich",
state_danger: "GEFAHR: Risiko akuter Toxizität",
oxygen_system_title: "Sauerstoff-Risikomodell",
oxygen_system_explainer: "Das System kombiniert akute Toxizität (PPO₂) und kumulative Toxizität (CNS). Der angezeigte Zustand spiegelt das dominierende Risikoniveau zu jedem Zeitpunkt des Tauchgangs wider, ähnlich einem echten technischen Tauchcomputer.",
logica_deco_engine: "Logik der Dekompressions-Engine (Bühlmann + GF)",
resumen_logica_deco: "Dieses Modul berechnet in Echtzeit den Dekompressionsplan des Tauchers durch Simulation der Stickstoffsättigung der Gewebe, generiert obligatorische Stopps und passt das Aufstiegsprofil entsprechend dem physiologischen Zustand und dem Sicherheitsgradienten (GF) an. Es führt außerdem eine persistente Historie, um Fortschritte zwischen Neuberechnungen zu erhalten.",
generacion_plan: "Erzeugung des Dekompressionsplans",
plan_buhlmann: "Das System erstellt ein Stopp-Profil basierend auf dem Bühlmann-Modell mit Gradient Factors.",
calculo_ceiling: "Berechnung des Ceiling mit GF-Linie (sichere Aufstiegsgrenze)",
redondeo_paradas: "Rundung auf Stufenstopps (STOP_STEP_M)",
simulacion_exposicion: "Simulation der Gewebebelastung pro Stopp",
condicion_fin: "Endet, wenn das Ceiling unter 3 m fällt (STOP_REQUIRED_M)",
modo_preview: "Vorschau-Modus ohne Einfluss auf die reale Historie",
historial_persistencia: "Stopp-Historie und Persistenz",
deco_history: "Das System speichert den Fortschritt jedes Stopps, um Zustandsverluste bei Neuberechnungen zu vermeiden.",
decohistory_array: "decoHistory speichert Fortschritt nach Tiefe",
hydrate_paradas: "Hydration der Stopps aus der Historie",
preserva_progreso: "Bewahrt geleistete Zeit (timePerformedSec)",
evita_reset: "Verhindert Zurücksetzen bereits begonnener Stopps",
merge_plan: "Zusammenführung von neuem Plan und vorherigem Zustand",
update_deco_logic: "Die Engine berechnet kontinuierlich den Dekompressionszustand basierend auf Tiefe, simulierter Zeit und Geweben neu.",
control_parada_actual: "Kontrolle des aktuellen Stopps mit Tiefentoleranz",
bloqueo_orden: "Reihenfolgesperre (keine Überspringung vorheriger Stopps)",
regeneracion_dinamica: "Neuberechnung bei Verschlechterung oder Verbesserung des Profils",
acumulacion_tiempo: "Zeitakkumulation pro dtSimSec",
auto_complete: "Automatisches Abschließen bei 95% Erfüllung",
tts_dinamico: "Dynamische TTS-Berechnung (Aufstieg + Stopps)",
tts_resumen: "Gesamtaufstiegszeit (TTS)",
tts_explicacion: "Die TTS wird berechnet, indem die Aufstiegszeit abschnittsweise (basierend auf der Aufstiegsgeschwindigkeit) mit der verbleibenden Zeit in aktiven Dekompressionsstopps kombiniert wird. Das Ergebnis passt sich kontinuierlich dem realen Gewebezustand und dem aktuellen Plan an.",
uso_responsable: "Verantwortungsvolle Nutzung und wichtiger Hinweis",
herramienta_educativa: "Dieses Projekt ist ein Bildungs- und Demonstrationswerkzeug. Reales Tauchen erfordert Ausbildung, zertifizierte Ausrüstung und professionelle Aufsicht.",
importante: "Wichtig",
que_hace_3_txt: "Dieser Simulator <strong>ist kein</strong> Tauchkurs, <strong>ersetzt keine</strong> formale Ausbildung und <strong>ist kein</strong> Tauchcomputer oder operatives Planungswerkzeug. Er darf <strong>nicht</strong> zur Planung realer Tauchgänge oder für Entscheidungen verwendet werden. Alles Dargestellte dient <strong>ausschließlich illustrativen Zwecken</strong>, unter Verwendung von Konzepten und Algorithmen nur für Simulation und Visualisierung. Die Nutzung des Simulators liegt in der Verantwortung des Benutzers.",
ackCheck: "",
entiendo_educativo: "Ich verstehe, dass dieser Simulator nur zu Bildungszwecken dient, keine zertifizierte Ausbildung oder einen Tauchcomputer ersetzt und nicht zur Planung oder Durchführung realer Tauchgänge verwendet werden darf.",
enterBtn: "Simulator starten",
learnMoreBtn: "Systemdetails anzeigen",
faq_txt_2: "Häufig gestellte Fragen",
que_es: "Ist dies ein Tauchplaner?",
es_aprendizaje_visual: "Nein. Es ist ein visuelles Lernwerkzeug. Es darf nicht zur Planung realer Tauchgänge verwendet werden.",
que_gases_contempla: "Welche Gase werden berücksichtigt?",
cuales_gases: "Es werden Luft und Nitrox über den Sauerstoffanteil (FO₂) berücksichtigt, was NDL, Stickstoff sowie PPO₂/CNS beeinflusst.",
mobil_funciona: "Funktioniert es auf dem Handy?",
si_funciona_mobil: "Ja. Die Steuerung passt sich mit Joysticks und Pointer-Events an.",
team_txt_2: "Team",

se_descarga: "Muss es heruntergeladen werden?",
no_se_descarga: "Wir verwenden die <strong>3D-WebGL-Technologie</strong>, sodass Sie nichts aus einem App-Store herunterladen müssen und direkt in Ihrem Browser freien und unbegrenzten Zugriff haben.",

gonzalo_desc: "Tauchlehrer | Softwaretechniker",
title_footer: "Tauchsimulator",
footer_experiencia: "Bildungs- und Demonstrationserlebnis",
consejo_ambiental: "Umwelttipp: Gute Tarierung und bewusstes Bewegen schützen das Riff und die Meereslebewesen.",
modalTitle: "Systemübersicht",
closeModalBtn: "Schließen",
actualiza_indicadores: "Der Simulator aktualisiert Sicherheits- und physiologische Indikatoren während des virtuellen Tauchgangs und erstellt einen Abschlussbericht zu Lernzwecken.",
fisiologia: "Physiologie (Gewebe)",
compartimentos_2: "16 simulierte Kompartimente, Stickstoffbelastung und Schätzung von Ceiling/Aufstieg.",
ndl_nitros: "NDL und Nitrox",
ndl_recreativo: "Freizeit-NDL, FO₂-Unterstützung mit äquivalenter Tiefe (EAD) zu Bildungszwecken.",
consumo_aire_2: "Luftverbrauch",
consumo_basado_sac: "Verbrauch basierend auf SAC, Umgebungsdruck und simulierter Zeit; Reserve- und „keine Luft“-Warnungen.",
oxigeno_cns: "Sauerstoff (PPO₂ / CNS)",
calculo_ppo2: "Berechnet PPO₂ basierend auf Tiefe und FO₂; akkumuliert CNS-Exposition und zeigt Warnungen an.",
fines_educativos: "Hinweis: Alle Werte und Visualisierungen dienen ausschließlich Bildungs- und Simulationszwecken.",
closeSlideBtn: "❌",

safety_stop_menu: "Sicherheitsstopp",
nitrogen_bar_menu: "N₂-Leiste",
consumo_aire_menu: "Gasverbrauch",
oxicidad_oxigeno_menu: "O₂-Toxizität",
deco_menu: "DECO",
deco_y_paradas_deco: "DECO und seine Dekompressionsstopps",

registro_existoso: "Registrierung abgeschlossen!",
instrucciones_email_registro: "Ihr Konto wurde erfolgreich erstellt. Bitte bestätigen Sie Ihr Konto in Ihrer E-Mail, um sich anzumelden! Vielen Dank",
cintinuar: "Weiter",


},


payment_stripe:{

  title:"Sichere Zahlung mit Stripe",
  ammount_txt:"Gesamtbetrag:<br>",
  currency:"Euro",
  pagar_ahora:"Jetzt bezahlen",
  continuar:"Weiter",
  cancelar:"Abbrechen",
  error: "Fehler",
  completa_inputs:"Bitte füllen Sie alle Felder aus",
  close:"Schließen",
  error_passwords:"Passwortfehler",
  passwords_no_iguales:"Die Passwörter stimmen nicht überein",
  error_email: "E-Mail-Fehler",
  ingresa_email_valido:"Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  user_data:"Benutzerdaten",
  create_account:"Neues Konto erstellen",
  pago_exitoso:"Zahlung erfolgreich",
  pago_compeltado:"Ihre Zahlung wurde erfolgreich abgeschlossen",
  pago_proceso:"Zahlung wird verarbeitet",
  confirmaremos_pago:"Wir werden Ihre Zahlung in Kürze bestätigen",
  pago_fallido:"Zahlung fehlgeschlagen",
  fallo_autenticacion_declinado:"Authentifizierung fehlgeschlagen oder Zahlung abgelehnt",
  status_pago:"Zahlungsstatus",
  cuenta_existente:"Dieses Konto existiert bereits",
  cuenta_existente_txt:"Diese E-Mail-Adresse wurde bereits registriert"

},




login:{

  iniciar_session: "Anmelden",
  accede_a_cuenta:"Greifen Sie auf Ihr Konto zu",
  email:"E-Mail",
  password:"Passwort",
  iniciar_session_btn:"Jetzt anmelden",
  verificando:"Wird überprüft.....",
  credenciales_incorrectas:"Falsche Anmeldedaten"

},


stripe_user_data:{
  user_data:"Benutzerdaten",
  create_account:"Neues Konto erstellen",
  username:"Benutzername",
  enter_username:"Vollständigen Namen eingeben",
  email_user:"E-Mail des Benutzers",
  enter_email:"E-Mail eingeben",
  password:"Passwort",
  enter_password:"Passwort eingeben",
  repeat_password:"Passwort wiederholen",
  enter_repeat_password:"Geben Sie dasselbe Passwort ein",
  seleccion_suscripcion:"Abonnementtyp auswählen",
  mensual:"Monatlich",
  semestral:"Halbjährlich",
  anual:"Jährlich"
},


cookies:{
  title:"Erforderliche Cookies",
  message:"Diese Website benötigt Cookies, um ordnungsgemäß zu funktionieren. Sie müssen deren Verwendung akzeptieren, um fortzufahren.",
  reject:"Ablehnen",
  accept:"Akzeptieren",
  acceso_denegado:"Zugriff verweigert",
  debes_aceptar:"Die Zustimmung zu Cookies ist erforderlich, um fortzufahren"
},


condiciones:{

  full:  ` 


<div id="legal_conditions" class="legal_conditions">

<div class="legal_header">
<h1>Nutzungsbedingungen</h1>
</div>


<div id="legal_scroll_container" class="legal_scroll_container">


<div class="section_legal">

<h2>1. IDENTIFIKATION DES VERANTWORTLICHEN</h2>

<p>
Gemäß dem Gesetz 34/2002 über Dienste der Informationsgesellschaft (LSSI-CE)
wird darüber informiert, dass diese Website Eigentum ist von:
</p>

<ul>
<li><strong>DIVANTIS</strong></li>
<li><strong>Kontakt E-Mail:</strong> admin@divantys.com</li>
<li><strong>Steuerlicher Sitz:</strong> Málaga, Spanien</li>
<li><strong>Tätigkeit:</strong> Bereitstellung digitaler Remote-Dienstleistungen</li>
</ul>

</div>


<div class="section_legal">

<h2>2. ZWECK UND NUTZUNGSBEDINGUNGEN</h2>

<p>
Diese Website bietet digitale Dienstleistungen, interaktive Inhalte
und Online-Tools an. Der Zugriff auf die Website bedeutet die
Akzeptanz dieser Nutzungsbedingungen.
</p>

<p>Der Nutzer verpflichtet sich:</p>

<ul>
<li>Keine illegalen Aktivitäten durchzuführen</li>
<li>Keinen schädlichen Code einzuführen</li>
<li>Nicht zu versuchen, auf geschützte Systeme zuzugreifen</li>
<li>Die Website nicht für betrügerische Zwecke zu nutzen</li>
</ul>

</div>


<div class="section_legal">

<h2>3. GEISTIGES EIGENTUM</h2>

<p>
Alle Inhalte dieser Website (Texte, Code, Design, Software und Bilder)
sind Eigentum des Betreibers oder entsprechend lizenziert.
Die Vervielfältigung, Verbreitung oder Änderung ohne ausdrückliche
Genehmigung ist untersagt.
</p>

</div>


<div class="section_legal">

<h2>4. VERFÜGBARKEIT DES DIENSTES</h2>

<p>
Der Betreiber kann jederzeit Funktionen oder Dienste
der Website ändern, aussetzen oder einstellen,
ohne vorherige Ankündigung.
</p>

</div>


<div class="section_legal">

<h2>5. HAFTUNGSAUSSCHLUSS</h2>

<p>
Die Website wird „wie besehen“ bereitgestellt.
Der Betreiber garantiert weder eine kontinuierliche
Verfügbarkeit noch die Fehlerfreiheit der Informationen.
</p>

<p>
Der Betreiber haftet nicht für Schäden,
die durch die Nutzung oder die Unmöglichkeit der Nutzung
der angebotenen Dienste entstehen.
</p>

</div>


<div class="section_legal">

<h2>6. DATENSCHUTZRICHTLINIE (DSGVO)</h2>

<h3>Erhobene Daten</h3>

<ul>
<li>Name</li>
<li>E-Mail-Adresse</li>
<li>Daten, die über Formulare übermittelt werden</li>
<li>Technische Navigationsdaten</li>
</ul>

<h3>Zweck</h3>

<ul>
<li>Beantwortung von Anfragen</li>
<li>Versenden angeforderter Informationen</li>
<li>Verbesserung des Dienstes</li>
<li>Kommerzielle Kommunikation (mit Einwilligung)</li>
</ul>

</div>


<div class="section_legal">

<h2>7. DATENSPEICHERUNG</h2>

<p>
Personenbezogene Daten werden nur so lange gespeichert,
wie es zur Erfüllung der in dieser Richtlinie beschriebenen
Zwecke oder zur Einhaltung gesetzlicher Verpflichtungen erforderlich ist.
</p>

</div>


<div class="section_legal">

<h2>8. DIENSTE DRITTER</h2>

<p>
Diese Website kann Dienste Dritter nutzen,
wie Zahlungsanbieter, Hosting-Anbieter oder Analyse-Tools.
</p>

<p>
Diese Anbieter können bestimmte technische oder personenbezogene Daten
gemäß ihren eigenen Datenschutzrichtlinien verarbeiten.
</p>

</div>


<div class="section_legal">

<h2>9. INTERNATIONALE DATENÜBERMITTLUNGEN</h2>

<p>
Wenn Technologieanbieter außerhalb des
Europäischen Wirtschaftsraums eingesetzt werden,
werden die von der Europäischen Kommission
genehmigten Standardvertragsklauseln angewendet.
</p>

</div>


<div class="section_legal">

<h2>10. COOKIE-RICHTLINIE</h2>

<p>
Die Website kann technische und analytische Cookies verwenden,
um die Benutzererfahrung und die Funktionalität der Website
zu verbessern.
</p>

</div>


<div class="section_legal">

<h2>11. ÄNDERUNGEN</h2>

<p>
Der Betreiber kann diese Richtlinien jederzeit ändern.
Änderungen treten mit ihrer Veröffentlichung auf der Website in Kraft.
</p>

</div>


<div class="section_legal">

<h2>12. ANWENDBARES RECHT UND GERICHTSBARKEIT</h2>

<p>
Diese Bedingungen unterliegen dem spanischen Recht.
Die Parteien unterwerfen sich den Gerichten von Málaga, Spanien.
</p>

</div>


<div class="section_legal">

<h2>13. KONTAKT</h2>

<p>
Für Fragen zu diesen Richtlinien:
</p>

<p>
📧 admin@divantys.com
</p>

</div>


</div>



<div class="legal_controls">

<button id="legal_continue_btn">
Akzeptieren und fortfahren
</button>

</div>

</div>

    ` 

},



  // ===================================================
  // GENERAL
  // ===================================================
  general: {
    ok: "OK",
    cancel: "Abbrechen",
    salir: "Beenden",
    button_fisiologia: "Tauchphysiologie",
    closeReset: "Schließen und zurücksetzen",
    startDive: "Tauchgang starten",
    startNextDive: "Nächsten Tauchgang starten",
    firstDive: "Erster Tauchgang",
    repetitiveDive: "Wiederholungstauchgang",
    Dive: "Tauchgang #",
    reduce_ascent_speed: "Eine reduzierte Aufstiegsgeschwindigkeit verringert die Stickstoffbelastung.",
    controlled_ascent_text:
      "Denke daran, dass Aufstiege langsam und kontrolliert erfolgen müssen, um eine Gewebesättigung zu vermeiden. Nutze die „Stickstoffbelastung“ als Referenz."
  },

  // ===================================================
  // ALERTS / MESSAGES
  // ===================================================
  alerts: {
    notice: "Hinweis",
    invalidSurface: "Ungültiges Oberflächenintervall",
    noRepetitive: "Nach diesem Tauchgang sind keine Wiederholungstauchgänge erlaubt",
    noTissueData: "Keine Gewebedaten verfügbar",
    recalculating: "Gewebekompartimente werden neu berechnet…",

    outOfAir: {
      title: "🚨 Kein Atemgas",
      button: "Verstanden",
      html: `
        <strong>Kritische Situation erkannt.</strong><br><br>

        • Atemgasvorrat erschöpft<br>
        • Sofort mit einem kontrollierten Aufstieg beginnen<br>
        • Kontinuierliches Ausatmen (CESA)<br>
        • Sichere Aufstiegsgeschwindigkeit einhalten<br><br>

        <em>Dieser Tauchgang wurde aus Sicherheitsgründen beendet.</em>
      `
    },

    modExceeded: {
      icon: "🫁⚠️",
      color: "#c62828",
      title: "🚨 MOD für EAN{{ean}} überschritten",
      button: "Verstanden",
      html: `
        <strong>Du befindest dich tiefer als die sichere maximale Betriebstiefe für dieses Gas.</strong><br><br>

        <strong>Details:</strong><br>
        • Aktuelle Tiefe: <strong>{{depth}} m</strong><br>
        • MOD (PPO₂ 1,4): <strong>{{mod}} m</strong><br>
        • Maßnahme: <strong>sofort aufsteigen</strong> auf eine geringere Tiefe<br><br>

        <em>Dieser Tauchgang wurde aus Sicherheitsgründen beendet.</em>
      `
    },

    recreationalLimitExceeded: {
      icon: "🚫",
      color: "#c62828",
      title: "🚨 Sporttauchgrenzen überschritten",
      button: "Verstanden",
      html: `
        <strong>Du bist über die üblichen Grenzen des Sporttauchens hinausgetaucht.</strong><br><br>

        <strong>Das bedeutet:</strong><br>
        • Keine sporttauchrelevante Nullzeit mehr gültig<br>
        • Dekompression kann erforderlich sein<br>
        • Technische Ausbildung ist erforderlich<br>
        • Gasplanung und gestufte Aufstiege können notwendig sein<br><br>

        <em>Dieser Tauchgang wurde aus Sicherheitsgründen beendet.</em>
      `
    },

    ndlExceeded: {
      icon: "⏱",
      color: "#c62828",
      title: "🚨 Nullzeit überschritten",
      button: "Verstanden",
      html: `
        <strong>Die Nullzeit wurde überschritten.</strong><br><br>

        <strong>Erforderliche Maßnahme:</strong><br>
        • Sofort langsam und kontrolliert aufsteigen<br>
        • Maximale Aufstiegsgeschwindigkeit: <strong>9–10 m/min</strong><br>
        • Sicherheitsstopp bei <strong>5 m für 3–5 Minuten</strong> durchführen<br><br>

        <em>Dieser Tauchgang wurde aus Sicherheitsgründen beendet.</em>
      `
    },

    safetyStopInterrupted: {
      title: "Sicherheitsstopp unterbrochen",
      text: "Steige auf 5 Meter ab, um den Sicherheitsstopp neu zu starten.",
      color: "warning"
    },

    safetyStopCompleted: {
      title: "Sicherheitsstopp abgeschlossen",
      text: "Du kannst den Aufstieg sicher fortsetzen.",
      color: "success"
    },

    low_air_reserve_reached: {
      title: "Wenig Luft — Reserve erreicht",
      text: `
Deine Luftreserve wurde erreicht (≈35 bar).

• Beginne einen langsamen, kontrollierten Aufstieg
• Nicht schneller als 9–10 m/min
• Bereite den Sicherheitsstopp bei 5 m vor
• Ruhig bleiben und langsam atmen`,
      color: "warning"
    }
  },

  // ===================================================
  // LOGS / STATES
  // ===================================================
  logs: {
    decoRequired: "🚨 Dekompression erforderlich (sporttauchrelevant)",
    nearNDL: "⚠️ Nahe an der Nullzeitgrenze",
    highTissue: "🟠 Hohe Gewebebelastung (physiologisches Modell)",
    withinLimits: "✅ Tauchgang innerhalb der Sporttauchgrenzen"
  },

  // ===================================================
  // DIVE STATUS
  // ===================================================
  diveStatus: {
    completed: "✅ Tauchgang abgeschlossen",
    failedDeco: "🚨 Tauchgang fehlgeschlagen — Dekompression erforderlich",
    highTissue: "⚠️ Tauchgang abgeschlossen — Hohe Gewebebelastung",
    nearNDL: "⚠️ Tauchgang abgeschlossen — Nahe an der Nullzeitgrenze",
    dangerous_ascent: "🚨 Irgendwann hattest du einen unkontrollierten Aufstieg. Sei vorsichtig",
    fast_ascent: "⚠️ Irgendwann bist du schneller als die maximal erlaubte Aufstiegsrate (9 m/min) aufgestiegen. Kontrolliere immer deinen Aufstieg und antizipiere Tiefenänderungen"
  },

  // ===================================================
  // SAFETY STOP
  // ===================================================
  safetyStop: {
    title: "Sicherheitsstopp",
    completed: "✅ <strong>Sicherheitsstopp abgeschlossen</strong>",
    notCompleted: "⚠️ <strong>Sicherheitsstopp nicht abgeschlossen</strong>",
    timeAt5m: "Zeit bei 5 m",
    completedAfterInterruptions: "Mit Unterbrechungen abgeschlossen",
    back_5m: "⬆️ Zurück auf 5 m",
    hold_5m: "⏸ Bei 5 m bleiben",
    target_depth: "Zieltiefe: 5 m"
  },

  nitrogen_bar: {
    title: "N₂-Belastung (schnelle Gewebe)"
  },

  // ===================================================
  // REPORT / SUMMARY
  // ===================================================
  report: {
    diveNumber: "Tauchgang",
    time: "Zeit",
    maxDepth: "Max. Tiefe",
    gas: "Gas",
    tank: "Flasche",
    startPressure: "Startdruck",
    endPressure: "Enddruck",
    airUsed: "Verbrauchte Luft",
    sac: "SAC",
    reserveReached: "Reserve erreicht",
    ceiling: "Dekompressionsdecke",
    gf: "GF",
    tissueTitle: "Gewebekompartimente",
    tissueNote:
      "Rote Kompartimente zeigen limitierende Gewebe — keine verpflichtende Dekompression.",
    ceiling: "Dekompressionsdecke",
    safetystop: "Sicherheitsstopp"
  },

  camera_hud: {
    t1: "Neutralen Trim einstellen",
    level_ok: "✓ Neutral",
    level_hint: "Tippen ⦿ für neutralen Trim"
  },

  // ===================================================
  // PROFILE
  // ===================================================
  profile: {
    title: "Tiefenprofil"
  },

  // ===================================================
  // TISSUES
  // ===================================================
  tissues: {
    title: "Gewebekompartimente (N₂)",
    surfaceOffGassing: "Entsättigung an der Oberfläche",
    afterInterval: "Nach",
    minutes: "Min",
    offGas: "⬇ Entsättigung",
    onGas: "⬆ Sättigung",
    tissues_data_invalidos: "Keine Gewebeinformationen verfügbar"
  },

  // ===================================================
  // SURFACE INTERVAL
  // ===================================================
  surface: {
    title: "Oberflächenintervall (Min)",
    invalid_interval_surface: "Ungültige Dauer des Oberflächenintervalls",
    recalc: "Gewebe neu berechnen",
    after: "Nach",
    notAllowed: "Nach diesem Tauchgang sind keine Wiederholungstauchgänge erlaubt"
  },

  // ===================================================
  // REPETITIVE DIVES
  // ===================================================
  repetitive: {
    tag: "Wiederholungstauchgang",
    info:
      "Dieser Tauchgang beginnt mit Reststickstoff aus einem vorherigen Tauchgang. Ein konservativer Aufstieg und ein vollständiger Sicherheitsstopp werden empfohlen.",
    first_dive: "Erster Tauchgang",
    repetitive_dive: "Wiederholungstauchgang"
  },

  // ===================================================
  // EDUCATION / LEGAL NOTICE
  // ===================================================
  education: {
    longHTML: `
<strong>ℹ️ Warum ist diese Meldung erschienen?</strong><br><br>

<strong>Während dieser Simulation blieb das Profil innerhalb der dargestellten Nullzeitgrenzen.</strong>
Zu keinem Zeitpunkt erreichte die vom System dargestellte dynamische Nullzeit (NDL)
den Wert null, noch wurden verpflichtende Dekompressionsstopps innerhalb der Simulation erzeugt.
<br><br>

Die angezeigte Meldung <strong>weist nicht auf einen Fehler, einen fehlgeschlagenen Tauchgang oder eine Regelverletzung hin</strong>.
Sie ist rein informativ und ergibt sich aus
<strong>dem gleichen internen physiologischen Modell</strong>, das während der gesamten Simulation konsistent angewendet wurde.
<br><br>

<strong>Wie funktioniert dieser Simulator?</strong><br>
Dieser Simulator ist ein <strong>Visualisierungs- und Illustrationswerkzeug</strong>,
das dazu dient, allgemeine Konzepte der Tauchphysiologie darzustellen.
Er basiert auf einem <strong>theoretischen Modell zur kontinuierlichen Gewebeverfolgung</strong>,
inspiriert von gut dokumentierten Dekompressionsmodellen
(z. B. Bühlmann ZHL-16C mit Gradient-Faktoren),
und wird ausschließlich zu Darstellungszwecken eingesetzt.
<br><br>

Während des simulierten Tauchgangs:
<ul style="margin:8px 0 0 18px;">
  <li>werden relative Schätzungen der Inertgasaufnahme in theoretischen Gewebekompartimenten dargestellt</li>
  <li>wird die Annäherung dieser Gewebe an modellierte Grenzwerte visualisiert</li>
  <li>wird die Konservativität des Aufstiegs <em>ausschließlich innerhalb der Simulation</em> veranschaulicht</li>
</ul>
<br>

<strong>Warum kann ein Hinweis erscheinen, obwohl die Nullzeit eingehalten wurde?</strong><br>
Auch wenn keine Dekompressionspflicht dargestellt wird,
kann das Modell <strong>relativ hohe Inertgasbelastungen</strong>
in bestimmten simulierten Geweben anzeigen.
Dies kann bei Profilen auftreten mit:
<ul style="margin:8px 0 0 18px;">
  <li>langen Grundzeiten</li>
  <li>Expositionen nahe der Nullzeitgrenze</li>
  <li>moderaten Tiefen über längere Zeiträume</li>
</ul>
<br>

In solchen Fällen kann das System eine
<strong>präventive Informationsmeldung</strong> anzeigen,
deren einziger Zweck darin besteht, zusätzlichen physiologischen Kontext innerhalb der Visualisierung zu liefern.
Diese Meldung <strong>stellt keine operative Anweisung oder Tauchempfehlung dar</strong>.
<br><br>

<strong>🟠 Wichtige Klarstellung:</strong><br>
Diese Meldung <strong>stellt keine Dekompressionsanforderung dar</strong>,
<strong>ist kein Alarm und keine Anweisung eines Tauchcomputers</strong>
und <strong>impliziert keine unsicheren, falschen oder regelwidrigen Praktiken</strong>.
Sie zeigt lediglich, dass innerhalb des simulierten Modells
bestimmte Gewebe eine relativ höhere Inertgasbelastung aufwiesen
als bei einem typischen kurzen Sporttauchgang.
<br><br>

<strong>Einfach gesagt:</strong><br>
Das simulierte Profil blieb innerhalb der dargestellten Grenzen.
Diese Meldung bedeutet lediglich:
<em>„Dieses simulierte Szenario näherte sich einem konservativen Bereich, daher werden zusätzliche Kontextinformationen angezeigt.“</em>
<br><br>

<strong>Rechtlicher Hinweis:</strong><br>
Dieser Simulator wird <strong>ausschließlich zu Visualisierungs- und Illustrationszwecken</strong> bereitgestellt.
<strong>Er ist kein Tauchcomputer</strong>,
<strong>ersetzt keine zertifizierte Ausbildung und nicht die Bildungsfunktion anerkannter Tauchorganisationen</strong>,
und <strong>darf nicht als Entscheidungsgrundlage für reale Tauchgänge verwendet werden</strong>.
`
  },

  // ===================================================
  // PRE-DIVE CHECK
  // ===================================================
  predive: {
    title: "Sicherheitscheck vor dem Tauchgang",
    subtitle: "Standardisierter Sicherheitscheck vor dem Tauchgang (BWRAF) und Gaswahl",
    selectGas: "Atemgas auswählen",
    start: "Tauchgang starten",
    cancel: "Abbrechen und zurücksetzen",
    descargar: "Bericht herunterladen",
    bwraf: {
      b: "BCD: aufblasen / entleeren, Inflator funktionsfähig",
      w: "Blei: richtige Menge, Schnellabwurf frei",
      r: "Befestigungen: Gurte, Schnallen und Flasche gesichert",
      a: "Luft: Ventil offen, atmen und Druck prüfen",
      f: "Final: Maske, Flossen, Computer, Buddy bereit"
    }
  },

  scale_time_home: {
  title: "Zeitskala der Simulation",
  text: `
    Dieser Simulator kann <strong>die Zeit beschleunigen</strong>, um
    physiologische Prozesse (NDL, Stickstoffbelastung,
    Aufstiegsverhalten) zu veranschaulichen, die beim realen Tauchen
    deutlich mehr Zeit in Anspruch nehmen.
    <br><br>
    Dies stellt <strong>keine Echtzeit</strong> dar und wird
    <strong>ausschließlich zu Bildungs- und Visualisierungszwecken</strong> verwendet.
  `,
  real_time: "Echtzeit",
  choose: "Wählen Sie die Simulationsgeschwindigkeit:",
  start: "Tauchgang starten"
},




comparativa_tablas_tejidos_bhulmann: {
  text: `
    <div style="display:flex; flex-direction:column; gap:14px; line-height:1.65; color:#eaf4ff;">

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:18px; font-weight:700; margin-bottom:8px;">
          🧠📊 Tabellen vs. Physiologisches Modell
        </div>
        <div style="font-size:14px; opacity:.95;">
          Beide werden verwendet, um die Nullzeitgrenze (NDL) zu berechnen, aber <strong>sie funktionieren nicht gleich</strong>.
          Deshalb können sie unterschiedliche Ergebnisse anzeigen.
        </div>
      </div>

      <div style="display:grid; gap:12px;">
        
        <div style="background:rgba(0,153,255,.10); border:1px solid rgba(0,153,255,.25); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🔵 Sporttauchtabellen (PADI / DSAT)
          </div>
          <div style="font-size:14px;">
            <div>⏱️ Geben eine <strong>feste Zeit</strong> basierend auf der Tiefe an.</div>
            <div>📚 Basieren auf Studien und Sicherheitsreserven.</div>
            <div>🧮 <strong>Berechnen nicht</strong> den Körper in Echtzeit.</div>
            <div>🟢 Einfach, schnell und leicht zu verstehen.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Beispiel: bei <strong>20 m</strong> zeigt die Tabelle etwa <strong>NDL ≈ 45 min</strong>.
          </div>
        </div>

        <div style="background:rgba(0,255,170,.08); border:1px solid rgba(0,255,170,.22); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🟢 Bühlmann-Modell (dieser Simulator)
          </div>
          <div style="font-size:14px;">
            <div>🧠 Simuliert <strong>16 virtuelle Gewebe</strong> im Körper.</div>
            <div>📈 Berechnet in Echtzeit die Aufnahme und Abgabe von Stickstoff.</div>
            <div>⚙️ Passt sich deinem tatsächlichen Tauchprofil an: <strong>Tiefe, Zeit und Gas</strong>.</div>
            <div>🎯 Dynamischer und realistischer.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Hier ist die <strong>NDL nicht fest</strong>: sie entspricht dem Zeitpunkt, an dem ein <strong>Dekompressionsstopp notwendig wird</strong>.
          </div>
        </div>

      </div>

      <div style="background:rgba(255,196,0,.10); border:1px solid rgba(255,196,0,.25); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          ⚠️ Warum stimmen sie nicht immer überein?
        </div>
        <div style="font-size:14px;">
          <div>📚 Sporttauchtabellen sind <strong>konservativer</strong>.</div>
          <div>🧠 Das Bühlmann-Modell berechnet kontinuierlich, was im Körper passiert.</div>
          <div>🔍 Deshalb kann der Simulator eine andere NDL anzeigen als klassische Tabellen.</div>
        </div>
      </div>

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          💡 Zusammenfassung
        </div>
        <div style="font-size:14px;">
          <div>🔵 <strong>Tabellen</strong> = einfache, konservative Annäherung</div>
          <div>🟢 <strong>Bühlmann</strong> = realistischere physiologische Simulation</div>
        </div>

        <div style="margin-top:10px; font-size:14px; font-weight:600;">
          👉 Dieser Simulator verwendet das Bühlmann-Modell für eine dynamischere NDL-Berechnung.
        </div>
      </div>

    </div>
  `
},


block_student: {
    riesgo_accidente_disbarico: "Hohes Risiko für Dekompressionsunfälle",
    riesgo_microburbujas: "Risiko von Mikroblasen",
    reducir_velocidad: "Aufstiegsgeschwindigkeit auf 9m/min reduzieren",
    ascenso_ideal: "Ideale Aufstiegsgeschwindigkeit",
    ascenso_lento: "Langsamer Aufstieg. Korrekt",
    ascent_rate: "Aufstiegsgeschwindigkeit"
},

dashboard:{
  
    profile_txt: "Mein Profil",
    logout_txt:"Abmelden",
    welcome_label:"Willkommen",
    payments_title:"Zahlungsübersicht",
    startSimulatorBtn:"🎮 Tauchsimulator starten",
    view_payments:"Zahlungen anzeigen",
    view_simulator_logs:"Simulator-Protokolle",
    paymentsEmpty:"Zahlungen werden geladen...",
    response_title:"Zahlungen",
    activo_con_previa_cancelacion: "🎮 Zugriff aktiv (geplante Kündigung)",
    fecha_cancelacion_suscripcion: "⚠️ Ihr Abonnement wird gekündigt am:",
    en_proceso_cancelacion: "🟠 Kündigung läuft",
    acceso_hasta: "Zugriff verfügbar bis:",
    despues_esta_fecha_no_acceso: "Nach diesem Datum wird der Zugriff automatisch entzogen",
    suscripcion_finalizada: "💳 Abonnement beendet",
    suscripcion_cancelada: "🔴 Abonnement gekündigt",
    acceso_habiliatdo: "🟢 Zugriff aktiviert:",
    upgrade_plan : "Plan ändern",
    modificar_a :"Ändern zu:",
    tienes_el_plan_maximo: "✨ Sie haben den maximalen Plan.",
    reactivar_suscripcion: "🔄 Abonnement reaktivieren",
    cancelar_suscripcion: "❌ Abonnement kündigen",
    en_proceso: "⏳ Verarbeitung...",
    cancelando: "⏳ Kündigung...",
    cancelada: "✅ Gekündigt",
    error: "❌ Fehler",
    reactivando_suscripcion: "⏳ Reaktivierung...",
    reactivada: "✅ Reaktiviert",
    no_pagos_aun: "Noch keine Zahlungen vorhanden.",
    pagar: "💳 Bezahlen",
    pagado: "💳 Bezahlt",
    activar_acceso_simulador: "💳 Zugriff auf den Simulator aktivieren",
    sin_suscripcion_inactiva: "🔴 Kein aktives Abonnement",
    membresia_title: "Mitgliedschaft",
    credits_title: "Guthaben",
    add_saldo: "Guthaben aufladen"
    
}





}
